{/* Auto-generated icon - do not edit */}
import React from 'react'

interface ArrowIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const ArrowIcon = React.forwardRef<SVGSVGElement, ArrowIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 115 117"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M53.5315 80.8966C47.0901 88.1434 41.0469 95.0151 34.9222 101.806C31.4839 105.62 27.9103 109.311 24.3951 113.056C24.1768 113.311 23.9351 113.544 23.6733 113.753C18.8397 117.256 17.402 117.887 13.1202 113.544C10.6975 111.086 7.92899 108.974 5.37667 106.639C4.2169 105.59 3.14721 104.446 2.17885 103.216C0.556138 101.128 0.634278 99.5264 2.3091 97.4943C3.30188 96.2883 4.30763 95.0889 5.37858 93.9536C14.1151 84.6942 22.8597 75.4421 31.6123 66.1991C32.2839 65.4892 32.9223 64.7483 33.5497 64.0515C29.2092 59.4578 24.9743 55.0314 20.8051 50.5423C18.529 48.0918 16.3382 45.5588 14.1605 43.022C12.6987 41.3226 12.7189 39.839 14.3839 38.3978C15.4824 37.4504 16.7174 36.6751 18.0469 36.0982C27.4496 32.0457 36.7923 27.8264 46.3319 24.1216C61.7896 18.1193 77.3923 12.4917 92.9145 6.65672C96.7684 5.2083 100.536 3.53238 104.374 2.04079C105.898 1.36451 107.502 0.886158 109.147 0.617676C113.181 0.167978 115.249 2.77861 113.975 6.66247C112.998 9.62996 111.76 12.5086 110.686 15.4434C103.012 36.4047 95.4089 57.3923 87.6471 78.3226C85.2433 84.8053 82.4513 91.1456 79.7687 97.5211C78.7453 99.9545 76.6347 100.704 74.2896 99.3826C72.9815 98.5381 71.7698 97.5531 70.6748 96.4452C64.9616 91.2887 59.2751 86.1087 53.5315 80.8966ZM20.5862 41.3953C27.434 47.9492 33.6506 54.0056 39.9987 59.9203C42.3934 62.1518 42.7347 63.2356 40.9107 65.8683C40.5218 66.4148 40.0994 66.9357 39.6457 67.4286C33.9079 73.8289 28.2117 80.2678 22.4062 86.6054C18.0416 91.3691 13.5384 96.0027 8.86378 100.939L18.5303 109.019C21.1777 106.218 23.672 103.678 26.0556 101.037C33.5353 92.7502 40.9369 84.3929 48.4446 76.1336C51.5786 72.6851 53.3648 72.5863 57.0434 75.4205C61.1071 78.5527 65.1211 81.7503 69.1237 84.9635C70.7432 86.2629 72.2727 87.6741 74.1326 89.2853C84.1105 62.8638 93.936 36.8472 103.875 10.53C75.9839 20.2959 48.4022 29.9116 20.5862 41.3953Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="114" height="117" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

ArrowIcon.displayName = 'ArrowIcon'
